import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Dialog from 'components/Dialog'
import {emailInvalidRecipientUniq, emailInvalidRecipientGdpr,
    emailInvalidRecipientAdrs, emailInvalidRecipientEmpt,
    emailPersonalDataOversize} from 'utils/helpers'

const statuses = {
    unique: emailInvalidRecipientUniq,
    gdpr: emailInvalidRecipientGdpr,
    format: emailInvalidRecipientAdrs,
    empty: emailInvalidRecipientEmpt,
    oversize: emailPersonalDataOversize
}

const Row = styled.div`
    display: flex;
    background-color: #FFF;

    :nth-child(2n) {
        background-color: #eaf3f5;
    }

    :last-child {
        border-bottom: 2px solid #415dd4;
    }
`

const Cell = styled.div`
    width: 50%;
    padding: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const Header = styled(Cell)`
    background-color: #415dd4;
    font-weight: 400;
    color: #fff;
`

const Status = styled(Cell)`
    color: #d45b4a;
    letter-spacing: 1px;
`

const Text = styled.div`
    margin-bottom: 20px;
    line-height: 1.5;
`

const SendingError = ({successes, errors, title, handleClose, intl}) => (
    <Dialog
        open={!!errors}
        maxWidth='md'
    >
        <DialogTitle>
            {intl.formatMessage({id: "sidebar.send_to"}, {...title})}
        </DialogTitle>
        <DialogContent>
            <Text>
                {successes ?
                    <React.Fragment>
                        {intl.formatMessage({id: "sidebar.email_sent_to_only"})}
                        <span style={{fontWeight: 'bold'}}>
                             {' ' + intl.formatMessage({id: "sidebar.recipients_count"}, {count: successes.length})}
                        </span><br />
                        {intl.formatMessage({id: "sidebar.email_not_sent_to"})}
                    </React.Fragment> :
                    intl.formatMessage({id: "sidebar.no_valid_recipients"})
                }
            </Text>
            <div>
                <Row>
                    <Header>{intl.formatMessage({id: "sidebar.status"})}</Header>
                    <Header>{intl.formatMessage({id: "sidebar.address"})}</Header>
                </Row>
                {errors.map((error, index) => {
                    const status = Object.keys(statuses).find(item => statuses[item] === error.status)
                    return <Row key={index}>
                        <Status>
                            {status ?
                                intl.formatMessage({id: `sidebar.error_${status}`}) :
                                intl.formatMessage({id: "sidebar.error_unknown"})
                            }
                        </Status>
                        <Cell>
                            {error.address ? error.address :
                                intl.formatMessage({id: "sidebar.no_address"})}
                        </Cell>
                    </Row>
                })}
            </div>
        </DialogContent>
        <DialogActions>
            {/*<Button onClick={handleReset} color="primary">
                {intl.formatMessage({id: "app.confirm_cancel"})}
            </Button>*/}
            <Button onClick={handleClose} color="primary" variant="contained">
                {intl.formatMessage({id: "app.confirm_close"})}
            </Button>
        </DialogActions>
    </Dialog>
)

export default injectIntl(SendingError)
